import React, { useState } from 'react'
import { Box, IconButton, Stack } from '@mui/material'
import QuestionMarkRoundedIcon from '@mui/icons-material/QuestionMarkRounded'
import { HelpCenter } from '@workspace/frontend-kit'
import sxs from './styles/LoggedUserHeaderStyles'
import UserMenu from './UserMenu'
import { tracker } from '../../../../../tracking'

const LoggedUserHeader = () => {
    const [isOpen, setIsOpen] = useState(false)

    const handleOpenHelpCenter = () => {
        setIsOpen((prev) => !prev)
    }

    return (
        <>
            <Box sx={sxs.LoggedUserHeader}>
                <IconButton onClick={handleOpenHelpCenter}>
                    <Stack aria-label="ouvrir le centre d'aide" sx={sxs.LoggedUserIconOutline}>
                        <QuestionMarkRoundedIcon sx={sxs.LoggedUserIcon} />
                    </Stack>
                </IconButton>
                <UserMenu onOpen={handleOpenHelpCenter} />
            </Box>
            <HelpCenter
                open={isOpen}
                onClose={handleOpenHelpCenter}
                onClick={(card, action) =>
                    tracker.trackFeature('HelpCenter', { card, action }, { sendInstantly: action === 'email' })
                }
            />
        </>
    )
}

export default LoggedUserHeader
